import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Formik } from 'formik'
import { object as YupObject, string as YupString } from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { updateAccountUser } from '../Account/account.asyncActions'
import classNames from 'classnames'
import { selectUser } from './profile.selectors'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { fetchUser } from './profile.asyncActions'
import { CardTitle } from '../../components/ui/card'

const MyInformation = () => {
	const dispatch = useDispatch()

	const validationSchema = YupObject().shape({
		name: YupString().required('Name is required'),
		email: YupString()
			.email('E-mail is invalid')
			.required('E-mail is Required'),
	})

	const user = useSelector(selectUser)
	const formattedAssignedAccounts =
		user.accounts && user.accounts.map((each) => each.id)

	const { name, email } = user

	const initialValues = {
		name: name || '',
		email: email || '',
	}
	return (
		<Formik
			enableReinitialize={true}
			initialValues={initialValues}
			validationSchema={validationSchema}
			onSubmit={(values, { setSubmitting, resetForm }) => {
				const { accounts, ...formattedUsers } = user
				dispatch(
					updateAccountUser({
						...formattedUsers,
						...values,
						accounts: formattedAssignedAccounts,
					})
				).then(({ payload }) => {
					payload && dispatch(fetchUser({ id: payload }))
					setSubmitting(false)
				})
			}}
		>
			{({
				values,
				errors,
				touched,
				handleChange,
				handleBlur,
				handleSubmit,
			}) => (
				<Card className='p-4' onSubmit={handleSubmit}>
					<CardTitle>My Information</CardTitle>
					<CardContent className='p-6 space-y-4'>
						<div className='form-group'>
							<Label htmlFor='name'>Your Name</Label>
							<Input
								id='name'
								type='text'
								value={values.name}
								onChange={handleChange}
								onBlur={handleBlur}
								placeholder='Your Name'
								className={classNames({ error: touched.name && errors.name })}
							/>
							{touched.name && errors.name && (
								<div className='error-message'>{errors.name}</div>
							)}
						</div>
						<div className='form-group'>
							<Label htmlFor='email'>Your Email</Label>
							<Input
								id='email'
								type='email'
								value={values.email}
								onChange={handleChange}
								onBlur={handleBlur}
								placeholder='Your Email'
								className={classNames({ error: touched.email && errors.email })}
								readOnly
							/>
							{touched.email && errors.email && (
								<div className='error-message'>{errors.email}</div>
							)}
						</div>
						<Button type='button' onClick={() => handleSubmit()}>
							<BusyIndicator region={REGIONS.EDIT_ACCOUNT_USER}>Save</BusyIndicator>
						</Button>
					</CardContent>
				</Card>
			)}
		</Formik>
	)
}

export default MyInformation
